import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SeoService, SITE_URL } from '../../Shared/seo/seo.service';

// Import all section components
import { Hero } from '../../Components/Home/hero/hero';
import { Why } from '../../Components/Home/why/why';
import { Apps } from '../../Components/Home/apps/apps';
import { Features } from '../../Components/Home/features/features';
import { Working } from '../../Components/Home/working/working';
import { Pricing } from '../../Components/Home/pricing/pricing';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    CommonModule,
    Hero,
    Why,
    Apps,
    Features,
    Working,
    Pricing
  ],
  templateUrl: './home-page.html',
})
export class HomePageComponent implements OnInit {
  private headerHeight = 100; // Temporarily increased to test if logic works
  private seo = inject(SeoService);

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.seo.update({
      title: 'orderYaa ERP — All-in-One Business Management Software',
      description:
        'orderYaa ERP connects Sales, Inventory, Accounting, HR, CRM, Manufacturing, and Procurement in one platform. Free onboarding, unlimited users, no credit card required.',
      path: '/',
    });
    this.seo.setStructuredData('ld-organization', {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'orderYaa ERP',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      description:
        'All-in-one ERP platform for Sales, Inventory, Accounting, HR, CRM, Manufacturing, and Procurement.',
      url: SITE_URL,
      offers: {
        '@type': 'Offer',
        price: '5000',
        priceCurrency: 'PKR',
      },
    });
  }


  private scrollToFragmentWithOffset() {
    const fragment = window.location.hash.slice(1);
    if (fragment) {
      const element = document.getElementById(fragment);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 72;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }
}